import{isServer as i}from"lit";var n=`
.mc-notification__actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: var(--mds_core_notification_action-link_margin-right);
}
.mc-notification__actions > * {
  align-items: center;
  display: flex;
  position: relative;
}
.mc-notification__actions > *::after {
  @include apply-font('text', 'medium', 'normal');
  content: '\u2022';
  position: absolute;
  right: var(--mds_core_notification_action-link_separator_right);
}
.mc-notification__actions > *:last-child::after {
  display: none;
}
`,o=!1,c=()=>{if(!i){let e=document.head||document.getElementsByTagName("head")[0],t=document.createElement("style");t.type="text/css",t.appendChild(document.createTextNode(n)),e.appendChild(t),o=!0}};export{o as a,c as b};
//# sourceMappingURL=chunk.2ALDNS2I.js.map
